import React from 'react';
import PropTypes from 'prop-types';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import './Title.css';

const dumbTitle = dumbBem('l-title');
const TitleWrp = tx(dumbTitle)('div');

export const Title = ({
  children,
  ...rest
}) => {
  return (
    <TitleWrp {...rest}>
      {children}
    </TitleWrp>
  );
};

Title.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/landing/components/title/Title.js